import { useMemo } from 'react';
import { Editor } from '../Editor/Editor';
import { buildShootDoc } from '../../../shared/extractInterviewQuestions';

/**
 * The Brief tab: the fields chosen for the shoot view, as reading cards.
 *
 * The brief's presentation lives in CSS scoped to `.hsp-editor` (the internal
 * rail, the numbered questions, the client-side titles), so a hand-built card
 * would get none of it. This mounts one read-only editor over a doc of just
 * the chosen fields, exactly as the review page does, and `data-shoot-view`
 * on the wrapper turns each field into a card (styles.css, "Shoot view Brief
 * tab"). No comments, no tap targets: the page is for reading on set.
 */

interface Props {
  docJson: string;
  /** Admin only: internal fields wear their chip here as they do in the
   *  editor. The client route never receives an internal field at all. */
  audienceLabels?: boolean;
}

export default function ShootBriefTab({ docJson, audienceLabels = false }: Props) {
  const doc = useMemo(() => buildShootDoc(docJson), [docJson]);

  // data-brief-view="client" selects the read-only presentation CSS; it is
  // not an audience claim. Admin intentionally renders internal fields here,
  // marked by data-shoot-audience-labels.
  return (
    <div
      data-readonly="true"
      data-brief-view="client"
      data-shoot-view="true"
      data-shoot-audience-labels={audienceLabels ? 'true' : undefined}
      className="shoot-brief"
    >
      <Editor
        key={docJson}
        initialDoc={doc}
        onUpdate={() => {}}
        editable={false}
        briefControls={false}
        blockComments={false}
      />
    </div>
  );
}
